import { ProductBuildingBlock } from '@/gql/graphql';
import { DataBlocksTab } from '../details-building-block/tabs/data-blocks.tab';
import { DesignObligationTab } from '../details-building-block/tabs/design-obligation.tab';
import { GeneralDetailsTab } from '../details-building-block/tabs/general-details.tab';
import { InformationTab } from '../details-building-block/tabs/information.tab';

type BuildingBlockDataProps = {
  bb?: ProductBuildingBlock;
  bbTab: 'general-details' | 'information' | 'data-blocks' | 'design-obligation';
};

export const BuildingBlockData = ({ bb, bbTab }: BuildingBlockDataProps) => {
  if (!bb) return null;

  const renderTab = (
    bb: ProductBuildingBlock,
    tab: 'general-details' | 'information' | 'data-blocks' | 'design-obligation',
  ) => {
    switch (tab) {
      case 'general-details':
        return <GeneralDetailsTab bb={bb} />;
      case 'information':
        return <InformationTab bb={bb} />;
      case 'data-blocks':
        return <DataBlocksTab bb={bb} />;
      case 'design-obligation':
        return <DesignObligationTab bb={bb} />;
      default:
        return null;
    }
  };
  if (!bb) return null;
  return (
    <div className="bg-light-gray px-4">
      <div className="flex flex-col bg-white px-4 gap-y-2">{renderTab(bb, bbTab)}</div>
    </div>
  );
};
